<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <div v-else>
            <b-card>
                <div class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">
                        <i class="fa fa-fw fa-info-circle mr-2" />Detail Temuan
                        Emas
                    </h5>
                    <div v-if="canApprove">
                        <b-button variant="primary" @click="showModal()">
                            <i class="fa fa-check mr-2" /> Approve
                        </b-button>
                    </div>
                </div>
                <hr />
                <b-row v-if="data">
                    <b-col md="6">
                        <table class="table table-borderless table-sm">
                            <tr>
                                <td width="180">No. Faktur</td>
                                <td>
                                    :
                                    <strong>{{
                                        data.item.no_faktur || "-"
                                    }}</strong>
                                </td>
                            </tr>
                            <template v-if="!data.has_new_item">
                                <tr>
                                    <td>Nama Item</td>
                                    <td>: {{ data.item.name || "-" }}</td>
                                </tr>
                                <tr>
                                    <td>Tipe Emas</td>
                                    <td>
                                        :
                                        {{ data.item.gold_type || "-" }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Tipe Barang</td>
                                    <td>
                                        :
                                        {{ data.item.type || "-" }}
                                    </td>
                                </tr>
                            </template>
                            <tr>
                                <td>Status</td>
                                <td>
                                    :
                                    <b-badge
                                        :variant="
                                            getStatusBadge(data.status).badge
                                        "
                                        :class="
                                            getStatusBadge(data.status).class
                                        "
                                    >
                                        {{ getStatusBadge(data.status).text }}
                                    </b-badge>
                                </td>
                            </tr>
                        </table>
                    </b-col>
                    <b-col md="6">
                        <table class="table table-borderless table-sm">
                            <tr>
                                <td width="180">Dibuat Oleh</td>
                                <td>: {{ data.created_by_name || "-" }}</td>
                            </tr>
                            <tr>
                                <td>Dibuat Pada</td>
                                <td>
                                    : {{ $helper.parseDate(data.created_at) }}
                                    {{
                                        $helper.parseHourMinute(data.created_at)
                                    }}
                                </td>
                            </tr>
                            <tr v-if="data.completed_at && data.completed_by">
                                <td width="180">
                                    Selesai Oleh
                                </td>
                                <td>: {{ data.completed_by || "-" }}</td>
                            </tr>
                            <tr v-if="data.completed_at && data.completed_by">
                                <td width="180">
                                    Selesai Pada
                                </td>
                                <td>
                                    : {{ $helper.parseDate(data.completed_at) }}
                                    {{
                                        $helper.parseHourMinute(
                                            data.completed_at
                                        )
                                    }}
                                </td>
                            </tr>
                        </table>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6">
                        <b-card :header="data.has_new_item ? `Data Lama (${data.origin_source})` : `Data Awal (${data.origin_source})`">
                            <table class="table table-sm">
                                <template v-if="data.has_new_item">
                                    <tr>
                                        <td>Jenis</td>
                                        <td class="text-right">
                                            <strong>{{ data.origin_item.item_kind || "-" }}</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Merk</td>
                                        <td class="text-right">
                                            <strong>{{ data.origin_item.item_brand || "-" }}</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Tipe</td>
                                        <td class="text-right">
                                            <strong>{{ data.origin_item.item_type || "-" }}</strong>
                                        </td>
                                    </tr>
                                    <tr v-if="data.origin_item.gold_type">
                                        <td>Tipe Emas</td>
                                        <td class="text-right">
                                            <strong>{{ data.origin_item.gold_type }}</strong>
                                        </td>
                                    </tr>
                                    <tr v-if="data.origin_item.gold_mint_mark">
                                        <td>Merk Cap Emas</td>
                                        <td class="text-right">
                                            <strong>{{ data.origin_item.gold_mint_mark }}</strong>
                                        </td>
                                    </tr>
                                    <tr v-if="data.origin_item.piece_count">
                                        <td>Jumlah Keping</td>
                                        <td class="text-right">
                                            <strong>{{ data.origin_item.piece_count }} pcs</strong>
                                        </td>
                                    </tr>
                                    <tr v-if="data.origin_item.item_kind_id === ITEM_KIND.PERHIASAN">
                                        <td>Ada Cap</td>
                                        <td class="text-right">
                                            <strong>{{ data.origin_item.has_mark ? "Ada" : "Tidak Ada" }}</strong>
                                        </td>
                                    </tr>
                                    <tr v-if="data.origin_item.item_kind_id === ITEM_KIND.PERHIASAN">
                                        <td>Cap Getok</td>
                                        <td class="text-right">
                                            <strong>{{ data.origin_item.is_stamped ? "Ada" : "Tidak Ada" }}</strong>
                                        </td>
                                    </tr>
                                </template>
                                <tr>
                                    <td>Kadar</td>
                                    <td class="text-right">
                                        <strong>{{
                                            data.origin_purity || "-"
                                        }}</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Berat Kotor</td>
                                    <td class="text-right">
                                        <strong>{{
                                            data.origin_dry_weight || "-"
                                        }} gr</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Potongan</td>
                                    <td class="text-right">
                                        <strong>{{
                                            data.origin_weight_reduction || "-"
                                        }} gr</strong>
                                    </td>
                                </tr>
                                <tr v-if="data.origin_item.year && data.has_new_item">
                                    <td>Tahun</td>
                                    <td class="text-right">
                                        <strong>{{ data.origin_item.year }}</strong>
                                    </td>
                                </tr>
                            </table>
                        </b-card>
                        <b-card header="Hasil Operasional" v-if="isSupplierSource">
                            <table class="table table-sm">
                                <tr>
                                    <td width="150">Hasil</td>
                                    <td>
                                        :
                                        <template
                                            v-if="data.ops_accepted !== null"
                                        >
                                            <b-badge
                                                :variant="
                                                    data.ops_accepted
                                                        ? 'success'
                                                        : 'danger'
                                                "
                                            >
                                                {{
                                                    data.ops_accepted
                                                        ? "DITERIMA"
                                                        : "DISANGGAH"
                                                }}
                                            </b-badge>
                                        </template>
                                        <template v-else>
                                            -
                                        </template>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Oleh</td>
                                    <td>
                                        : {{ data.ops_result_by_name || "-" }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Pada</td>
                                    <td>
                                        :
                                        {{
                                            data.ops_result_at
                                                ? $helper.parseDate(
                                                      data.ops_result_at
                                                  ) +
                                                  " " +
                                                  $helper.parseHourMinute(
                                                      data.ops_result_at
                                                  )
                                                : "-"
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Catatan</td>
                                    <td>
                                        <b-form-textarea
                                            :value="data.ops_notes || '-'"
                                            readonly
                                            rows="2"
                                            max-rows="4"
                                            class="bg-white"
                                            style="font-size: 0.9rem;"
                                        />
                                    </td>
                                </tr>
                            </table>

                            <div
                                v-if="
                                    data.ops_media && data.ops_media.length > 0
                                "
                                class="mt-2"
                            >
                                <h6>Media Ops:</h6>
                                <div class="d-flex flex-wrap">
                                    <div
                                        v-for="(media, index) in data.ops_media"
                                        :key="index"
                                        class="mr-2 mb-2 bg-light rounded position-relative"
                                    >
                                        <a :href="media.url" target="_blank">
                                            <b-img-lazy
                                                v-if="!media.type || media.type === 'image'"
                                                :src="media.url"
                                                class="media-thumbnail"
                                                alt="Media Ops"
                                            />
                                            <div v-else-if="media.type === 'video'">
                                                <video
                                                    :src="media.url"
                                                    class="media-thumbnail"
                                                    preload="metadata"
                                                ></video>
                                                <div
                                                    style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: white; background-color: rgba(0,0,0,0.5); border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; pointer-events: none;"
                                                >
                                                    <i class="fa fa-play"></i>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </b-card>
                         <b-card header="Data Final (Approved)">
                            <table class="table table-sm">
                                <tr>
                                    <td>Kadar</td>
                                    <td>:
                                        <strong>{{
                                            data.final_purity || "-"
                                        }}</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Berat Kotor</td>
                                    <td>:
                                        <strong>{{
                                            data.final_dry_weight || "-"
                                        }} gr</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Potongan</td>
                                    <td>:
                                        <strong>{{
                                            data.final_weight_reduction || "-"
                                        }} gr</strong>
                                    </td>
                                </tr>
                                <tr v-if="isSupplierSource">
                                    <td>Kategori SM</td>
                                    <td>:
                                        <strong>{{
                                            data.final_sm_category || "-"
                                        }}</strong>
                                    </td>
                                </tr>
                                <tr v-if="isSupplierSource">
                                    <td>Kategori Supplier</td>
                                    <td>:
                                        <strong>{{
                                            data.final_supplier_category || "-"
                                        }}</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Catatan Final</td>
                                    <td>
                                        <b-form-textarea
                                            :value="data.final_notes || '-'"
                                            readonly
                                            rows="2"
                                            max-rows="4"
                                            class="bg-white"
                                            style="font-size: 0.9rem;"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Approved Oleh</td>
                                    <td>
                                        : {{ data.final_by_name || "-" }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Approved Pada</td>
                                    <td>
                                        :
                                        {{
                                            data.final_at
                                                ? $helper.parseDate(
                                                      data.final_at
                                                  ) +
                                                  " " +
                                                  $helper.parseHourMinute(
                                                      data.final_at
                                                  )
                                                : "-"
                                        }}
                                    </td>
                                </tr>
                            </table>
                        </b-card>
                    </b-col>

                    <b-col md="6">
                        <b-card :header="data.has_new_item ? 'Data Baru' : 'Data SM'">
                            <table class="table table-sm">
                                <template v-if="data.has_new_item && data.reset_request_item">
                                    <tr>
                                        <td>Jenis</td>
                                        <td class="text-right">
                                            <strong>{{ data.reset_request_item.item_kind || "-" }}</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Merk</td>
                                        <td class="text-right">
                                            <strong>{{ data.reset_request_item.item_brand || "-" }}</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Tipe</td>
                                        <td class="text-right">
                                            <strong>{{ data.reset_request_item.item_type || "-" }}</strong>
                                        </td>
                                    </tr>
                                    <tr v-if="data.reset_request_item.gold_type">
                                        <td>Tipe Emas</td>
                                        <td class="text-right">
                                            <strong>{{ data.reset_request_item.gold_type }}</strong>
                                        </td>
                                    </tr>
                                    <tr v-if="data.reset_request_item.gold_mint_mark">
                                        <td>Merk Cap Emas</td>
                                        <td class="text-right">
                                            <strong>{{ data.reset_request_item.gold_mint_mark }}</strong>
                                        </td>
                                    </tr>
                                    <tr v-if="data.reset_request_item.piece_count">
                                        <td>Jumlah Keping</td>
                                        <td class="text-right">
                                            <strong>{{ data.reset_request_item.piece_count }} pcs</strong>
                                        </td>
                                    </tr>
                                    <tr v-if="data.reset_request_item.item_kind_id === ITEM_KIND.PERHIASAN">
                                        <td>Ada Cap</td>
                                        <td class="text-right">
                                            <strong>{{ data.reset_request_item.has_mark ? "Ada" : "Tidak Ada" }}</strong>
                                        </td>
                                    </tr>
                                    <tr v-if="data.reset_request_item.item_kind_id === ITEM_KIND.PERHIASAN">
                                        <td>Cap Getok</td>
                                        <td class="text-right">
                                            <strong>{{ data.reset_request_item.is_stamped ? "Ada" : "Tidak Ada" }}</strong>
                                        </td>
                                    </tr>
                                </template>
                                <tr>
                                    <td>Kadar XRF</td>
                                    <td class="text-right">
                                        <strong>{{
                                            smData.purity || "-"
                                        }}</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Berat Kotor</td>
                                    <td class="text-right">
                                        <strong>{{
                                            smData.dry_weight || "-"
                                        }} gr</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Potongan</td>
                                    <td class="text-right">
                                        <strong>{{
                                            smData.weight_reduction || "-"
                                        }} gr</strong>
                                    </td>
                                </tr>
                                <tr v-if="data.has_new_item && data.reset_request_item && data.reset_request_item.year">
                                    <td>Tahun</td>
                                    <td class="text-right">
                                        <strong>{{ data.reset_request_item.year }}</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Kategori</td>
                                    <td class="text-right">
                                        <strong>{{
                                            data.sm_category || "-"
                                        }}</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Catatan Temuan</td>
                                    <td>: {{ data.sm_notes || "-" }}</td>
                                </tr>

                                <tr v-if="data.marked_by">
                                    <td>Suspect Oleh</td>
                                    <td>: {{ data.marked_by }}</td>
                                </tr>
                                <tr v-if="data.marked_at">
                                    <td>Suspect Pada</td>
                                    <td>
                                        :
                                        {{
                                            $helper.parseDate(data.marked_at) +
                                                " " +
                                                $helper.parseHourMinute(
                                                    data.marked_at
                                                )
                                        }}
                                    </td>
                                </tr>
                                <tr v-if="data.marked_note">
                                    <td>Catatan Suspect</td>
                                    <td>: {{ data.marked_note }}</td>
                                </tr>
                            </table>

                            <div v-if="data.marked_video" class="mt-2">
                                <h6>Video Suspect:</h6>
                                <div class="d-flex flex-wrap">
                                    <div class="mr-2 mb-2 bg-light rounded position-relative">
                                        <a :href="data.marked_video" target="_blank">
                                            <video
                                                :src="data.marked_video"
                                                class="media-thumbnail"
                                                preload="metadata"
                                            ></video>
                                            <div
                                                style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: white; background-color: rgba(0,0,0,0.5); border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; pointer-events: none;"
                                            >
                                                <i class="fa fa-play"></i>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <template v-if="data.sm_media && data.sm_media.length > 0">
                                <div v-if="data.sm_media.some(m => m.for === 'unbox')" class="mt-2">
                                    <h6>Video Unboxing:</h6>
                                    <div class="d-flex flex-wrap">
                                        <div
                                            v-for="(media, index) in data.sm_media.filter(m => m.for === 'unbox')"
                                            :key="'unbox-' + index"
                                            class="mr-2 mb-2 bg-light rounded position-relative"
                                        >
                                            <a :href="media.url" target="_blank">
                                                <video
                                                    v-if="media.type === 'video'"
                                                    :src="media.url"
                                                    class="media-thumbnail"
                                                    preload="metadata"
                                                ></video>
                                                <div
                                                    v-if="media.type === 'video'"
                                                    style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: white; background-color: rgba(0,0,0,0.5); border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; pointer-events: none;"
                                                >
                                                    <i class="fa fa-play"></i>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="data.sm_media.some(m => !m.for || m.for === 'media')" class="mt-2">
                                    <h6>Foto & Video Temuan:</h6>
                                    <div class="d-flex flex-wrap">
                                        <div
                                            v-for="(media, index) in data.sm_media.filter(m => !m.for || m.for === 'media')"
                                            :key="'media-' + index"
                                            class="mr-2 mb-2 bg-light rounded position-relative"
                                        >
                                            <a :href="media.url" target="_blank">
                                                <b-img-lazy
                                                    v-if="!media.type || media.type === 'image'"
                                                    :src="media.url"
                                                    class="media-thumbnail"
                                                    alt="Media SM"
                                                />
                                                <div v-else-if="media.type === 'video'">
                                                    <video
                                                        :src="media.url"
                                                        class="media-thumbnail"
                                                        preload="metadata"
                                                    ></video>
                                                    <div
                                                        style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: white; background-color: rgba(0,0,0,0.5); border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; pointer-events: none;"
                                                    >
                                                        <i class="fa fa-play"></i>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </b-card>

                        <ForumTemuan
                            v-if="data.id"
                            :variance-id="data.id"
                            :no-faktur="data.item.no_faktur"
                            :status="data.status"
                            @message-sent="getItems"
                        />
                    </b-col>
                </b-row>
            </b-card>
        </div>

        <ModalApproveTemuan
            ref="modalApproveTemuan"
            :item="data"
            :action="approveAction"
            @refresh="getItems"
        />

        <ModalApproval
            ref="modalApproval"
            :item="data"
            :attr="attr"
            mode="completion"
            :action="approveAction"
            :source="data.origin_item ? data.origin_item.source : null"
            @submit-completion="onCompletionApproved"
            @approved="getItems"
        />

        <ModalApproveIVN :item="data" @refresh="getItems" />
    </div>
</template>

<script>
import ModalApproveTemuan from "./ModalApproveTemuan.vue";
import ModalApproval from "../terima-emas-pei/ModalApproval.vue";
import EnumPermission from "@/shared/enum-permissions";
import ModalApproveIVN from "./ModalApproveIVN.vue";
import ForumTemuan from "./ForumTemuan.vue";

const ITEM_KIND = Object.freeze({
    PERHIASAN: 257,
    LM_RETRO: 261,
    LM_SCAN: 251,
});

export default {
    components: {
        ModalApproveTemuan,
        ModalApproval,
        ModalApproveIVN,
        ForumTemuan
    },
    data() {
        return {
            ITEM_KIND,
            initStatus: 0,
            isBusy: false,
            data: {},
            attr: {
                purity_xrf_tolerance: 20,
                dry_weight_tolerance: 0.05
            }
        };
    },

    computed: {
        smData() {
            if (this.data.has_new_item && this.data.reset_request_item) {
                return {
                    purity: this.data.reset_request_item.purity,
                    dry_weight: this.data.reset_request_item.dry_weight,
                    weight_reduction: this.data.reset_request_item.weight_reduction
                };
            }
            return {
                purity: this.data.sm_purity,
                dry_weight: this.data.sm_dry_weight,
                weight_reduction: this.data.sm_weight_reduction
            };
        },
        isPEISource() {
            return !!(this.data.origin_item && this.data.origin_item.source === "PEI");
        },
        isSupplierSource() {
            return !!(this.data.variance && this.data.variance.is_supplier_source);
        },
        canApprove() {
            if (this.data.status == 2 || this.data.status == 4) {
                return this.$helper.isAllowed(
                    EnumPermission.GOLD_RECEIPT_VARIANCE_AUDITOR.toString()
                );
            }

            if (this.data.status == 3) {
                return this.$helper.isAllowed(EnumPermission.PEI_RECEIVING.toString())
                    || this.$helper.isAllowed(EnumPermission.APPROVE_GOLD.toString());
            }

            return false;
        },

        approveAction() {
            if (this.data.status == 2 || this.data.status == 4) {
                return "approve";
            }

            if (this.data.status == 3) {
                return "complete";
            }

            return null;
        }
    },

    methods: {
        init() {
            this.initStatus = 0;
            this.getItems();
        },

        getItems() {
            this.isBusy = true;

            return this.$axios
                .get(`gold-receipt-variances/${this.$route.params.id}`)
                .then(res => {
                    const raw = res.data.data;
                    const v = raw.variance || {};
                    const o = raw.origin_item || {};
                    const origin = v.origin_type === "IVN" && !v.has_new_item
                        ? { purity: v.origin_purity, dry_weight: v.origin_dry_weight, weight_reduction: v.origin_weight_reduction }
                        : o;
                    this.attr = raw.attr;

                    this.data = {
                        ...raw,
                        id: v.id,
                        status: v.status,
                        created_at: v.origin_created_at,
                        created_by_name: v.origin_created_by,
                        completed_at: v.completed_at,
                        completed_by: v.completed_by,

                        item: {
                            no_faktur: o.no_faktur || v.no_faktur,
                            name: `${o.item_kind || ""}  ${o.item_brand ? "- " + o.item_brand : ""}`,
                            name_kind: o.item_kind,
                            brand: o.item_brand,
                            gold_type: o.gold_type,
                            type: o.item_type
                        },

                        origin_item: o,
                        origin_source: v.source || "-",
                        origin_purity: origin.purity,
                        origin_dry_weight: origin.dry_weight,
                        origin_weight_reduction: origin.weight_reduction,
                        marked_video: o.marked_video,
                        marked_note: o.marked_note,
                        marked_at: o.marked_at,
                        marked_by: o.marked_by,

                        sm_purity: v.sm_purity,
                        sm_dry_weight: v.sm_dry_weight,
                        sm_weight_reduction: v.sm_weight_reduction,
                        has_new_item: !!v.has_new_item,
                        reset_request_item: raw.reset_request_item || null,
                        sm_notes: raw.sm_notes,
                        sm_media: raw.sm_media,
                        sm_category: v.category,

                        ops_accepted: v.ops_accepted,
                        ops_result_at: v.ops_result_at,
                        ops_result_by_name: v.ops_result_by_name,
                        ops_media: raw.ops_media,
                        ops_notes: v.ops_notes,

                        final_purity: v.final_purity,
                        final_dry_weight: v.final_dry_weight,
                        final_weight_reduction: v.final_weight_reduction,
                        final_notes: raw.final_notes,
                        final_sm_category: v.sm_category,
                        final_supplier_category: v.supplier_category,
                        final_by_name: v.final_by,
                        final_at: v.final_at
                    };

                    this.initStatus = 1;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.initStatus = 2;
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        showModal() {
            if (this.data.origin_item.type === "IVN" && this.data.status == 3) {
                this.$bvModal.show("m-approve-ivn");
                return;
            }
            if (
                (this.data.origin_item.type === "PEI" ||
                    this.data.origin_item.type === "RBE") &&
                this.data.status == 3
            ) {
                this.$refs.modalApproval.show();
                return;
            }
            this.$bvModal.show("m-approve-temuan");
        },

        onCompletionApproved(payload) {
            this.isBusy = true;
            this.$axios
                .post(
                    `gold-receipt-variances/${this.data.id}/approve`,
                    payload
                )
                .then(res => {
                    this.$helper.toastSuccess(
                        this,
                        "Penerimaan berhasil disetujui"
                    );
                    this.$refs.modalApproval.showBarcode(res.data.data);
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.$refs.modalApproval.stopLoading();
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        getStatusBadge(status) {
            switch (status) {
                case 1:
                    return {
                        badge: "warning",
                        text: "MENUNGGU PENERIMAAN"
                    };
                case 2:
                    return {
                        badge: "secondary",
                        text: "MENUNGGU AUDIT"
                    };
                case 3:
                    return {
                        badge: "primary",
                        text: "DISETUJUI AUDIT",
                        class: "text-white"
                    };
                case 4:
                    return {
                        badge: "info",
                        text: "DALAM DISKUSI",
                        class: "text-white"
                    };
                case 99:
                    return {
                        badge: "success",
                        text: "SELESAI"
                    };
                default:
                    return {
                        badge: "light",
                        text: "-"
                    };
            }
        }
    },
    created() {
        this.init();
    }
};
</script>

<style scoped>
.media-thumbnail {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #e9ecef;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
}

.media-thumbnail:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    border-color: #adb5bd;
}
</style>
